import Axios from 'axios';
import { configure } from 'axios-hooks';

const useApi = (path: string) => {
    const axios = Axios.create({
        baseURL: path,
    })

    configure({ axios });
}

export default useApi;